import React, { useEffect, useState } from 'react';
import { Pressable, View, Text } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract } from '@fortawesome/pro-regular-svg-icons';
import UploadPreview from './UploadPreview';

import AddFile from './AddFile';

import {
  CREATE_FILE_UPLOAD,
} from './queries';


const EntityAttachments = ({ ownerType, ownerId, fileTypes, fileIds, setFileIds }) => {
  const [showFile, setShowFile] = useState(false);

  const [createFileUpload] = useMutation(CREATE_FILE_UPLOAD, {
    onCompleted: data => updateFileId(data.createFileUpload.fileUpload)
  });

  const updateFileId = (newFile) => {
    fileIds[newFile.name].push(newFile.id)
    setFileIds({...fileIds})
  }

  const uploadFile = ({ file, name }) => {
    createFileUpload({
      variables: {
        name: name,
        ownerType: ownerType,
        ownerId: parseInt(ownerId),
        file: file,
      }
    });
  };

  const lengthOrRequired = fileType => {
    const length = fileIds[fileType.name].length;

    if (length) {
      return <View><Text>{length}</Text></View>
    }

    if (fileType.required) {
      return <View style={{ color: 'red' }}><Text>Required</Text></View>;
    }

    return <View><Text>{length}</Text></View>;
  }

  return (
    <View>
      <View key={name} style={{ maxWidth: 600, marginTop: '20px' }}>
        <View style={{marginBottom: '10px'}}>
          <Text
            style={{fontWeight: 'bold', fontSize: '20px'}}
          >
            Files
          </Text>
        </View>
        {fileTypes?.map(fileType => (
          <View key={fileType.name}
            style={{display: 'flex', flexDirection: 'row', gap: '10px',
              marginBottom: '10px'
            }}
          >
            <View>
              <AddFile
                name={fileType.name}
                uploadFile={uploadFile}
              />
            </View>
            {fileIds[fileType.name] && fileIds[fileType.name].map(upload => (
              <Pressable key={upload.id} onPress={() => setShowFile(upload)}>
                <View style={{ marginRight: 10 }}>
                  <FontAwesomeIcon icon={faFileContract} />
                </View>
              </Pressable>
            ))}
            {lengthOrRequired(fileType)}
          </View>
        ))}
      </View>
      {showFile && showFile.id && (
        <UploadPreview
          handleClose={() => setShowFile(false)}
          id={showFile.id}
          show={showFile}
          setShow={setShowFile}
        />
      )}
    </View>
  );
};

export default EntityAttachments;
